import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export type ExpertisesIconProps = SvgIconProps

export function ExpertisesIcon(props: ExpertisesIconProps) {
  const { htmlColor } = props
  return (
    <SvgIcon width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="My_teleexpertise">
        <g>
          <g id="XMLID_00000173871986265979268220000010125106627619961260_">
            <g>
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M173.765,109.725v72.87c0,4.09-3.32,7.4-7.41,7.4h-14.67v-87.68h14.67
					C170.445,102.315,173.765,105.635,173.765,109.725z"
              />
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M167.575,11.375v73.24c0,0.76-0.62,1.38-1.37,1.38h-48.78l-16.91,16.32l-14.97,14.44
					c-0.85,1.02-2.51,0.42-2.51-0.91v-13.53v-3.49v-12.83h-16.99c-0.76,0-1.38-0.62-1.38-1.38v-73.24c0-0.76,0.62-1.38,1.38-1.38
					h100.16C166.955,9.995,167.575,10.615,167.575,11.375z M136.185,77.465v-10.78c-0.33-3.3-1.67-9.28-7.24-12.85
					c-1.5-0.97-3.05-1.58-4.43-1.95c-3.01,2.2-6.23,3.34-9.38,3.34c-0.12,0-0.23,0-0.35,0c-3.2,0.08-6.54-1.06-9.67-3.37
					c0,0,0,0-0.02,0c-1.4,0.36-2.99,0.95-4.54,1.98c-5.46,3.47-6.86,9.3-7.23,12.62v11.01H136.185z M128.105,36.695
					c0.1-0.32,0.93-3.2-0.5-4.15c-0.21-0.15-0.47-0.23-0.74-0.28c0.34-0.9,1.2-3.7,0.27-6.9c-0.26-0.88-1.08-3.24-3.3-5.06
					c-3.08-2.53-7.06-2.56-8.63-2.57c-0.08,0-0.13,0-0.16,0c-0.07,0-0.13,0-0.2,0s-0.13,0-0.2,0c-0.03,0-0.09,0-0.16,0
					c-1.57,0.01-5.56,0.04-8.63,2.57c-2.22,1.82-3.04,4.18-3.3,5.06c-0.93,3.2-0.08,6,0.25,6.9c-0.27,0.05-0.51,0.14-0.72,0.28
					c-1.44,0.95-0.61,3.83-0.5,4.15c0.41,1.37,1.24,2.26,1.72,2.68c0.31,1.23,1.3,4.45,4.3,7.02c0.64,0.55,3.62,3.11,7.15,3.01
					c0.03,0,0.05,0,0.09,0c0.03,0,0.06,0,0.1,0c3.51,0.1,6.5-2.46,7.14-3.01c2.99-2.57,3.98-5.79,4.29-7.02
					C126.855,38.955,127.685,38.065,128.105,36.695z"
              />
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M129.135,188.555v1.44h-27.16v-0.78v-31.43v-0.52c3.16,0,6.12-0.88,8.64-2.42
					c10.67,2.94,18.52,12.72,18.52,24.33V188.555z"
              />
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M112.605,121.225v9.4h-21.26v-9.4c0-1.63,1.32-2.95,2.95-2.95h15.35
					C111.285,118.275,112.605,119.595,112.605,121.225z"
              />
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M101.975,189.215v0.78h-27.16v-1.44v-9.38c0-11.61,7.85-21.39,18.51-24.33
					c2.53,1.54,5.48,2.42,8.65,2.42v0.52V189.215z"
              />
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M48.595,102.315v87.68h-14.95c-4.09,0-7.41-3.31-7.41-7.4v-72.87c0-4.09,3.32-7.41,7.41-7.41
					H48.595z"
              />
            </g>
            <g>
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M100.515,102.315h51.17
					h14.67c4.09,0,7.41,3.32,7.41,7.41v72.87c0,4.09-3.32,7.4-7.41,7.4h-14.67h-22.55h-27.16h-27.16h-26.22h-14.95
					c-4.09,0-7.41-3.31-7.41-7.4v-72.87c0-4.09,3.32-7.41,7.41-7.41h14.95h34.44"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="48.595"
                y1="189.995"
                x2="48.595"
                y2="102.315"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="37.935"
                y1="160.225"
                x2="37.935"
                y2="132.085"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="151.685"
                y1="189.995"
                x2="151.685"
                y2="102.315"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M100.515,102.315
					l16.91-16.32h48.78c0.75,0,1.37-0.62,1.37-1.38v-73.24c0-0.76-0.62-1.38-1.37-1.38H66.045c-0.76,0-1.38,0.62-1.38,1.38v73.24
					c0,0.76,0.62,1.38,1.38,1.38h16.99v12.83v3.49v13.53c0,1.33,1.66,1.93,2.51,0.91L100.515,102.315z"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M112.605,131.245v8.83
					c0,5.87-4.76,10.62-10.63,10.62c-2.94,0-5.59-1.19-7.52-3.11c-1.92-1.92-3.11-4.58-3.11-7.51v-8.64"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M74.815,188.555v-9.38
					c0-11.61,7.85-21.39,18.51-24.33"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="86.625"
                y1="175.505"
                x2="86.625"
                y2="189.215"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="101.975"
                y1="157.785"
                x2="101.975"
                y2="189.215"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M93.325,154.845
					c2.53,1.54,5.48,2.42,8.65,2.42"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M110.615,154.845
					c10.67,2.94,18.52,12.72,18.52,24.33v9.38"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M101.975,157.265
					c3.16,0,6.12-0.88,8.64-2.42"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="118.505"
                y1="175.505"
                x2="118.505"
                y2="189.215"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M112.605,130.625h-21.26
					v-9.4c0-1.63,1.32-2.95,2.95-2.95h15.35c1.64,0,2.96,1.32,2.96,2.95V130.625v0.62"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M136.185,66.685c-0.33-3.3-1.67-9.28-7.24-12.85c-1.5-0.97-3.05-1.58-4.43-1.95c-3.01,2.2-6.23,3.34-9.38,3.34
					c-0.12,0-0.23,0-0.35,0c-3.2,0.08-6.54-1.06-9.67-3.37c0,0,0,0-0.02,0c-1.4,0.36-2.99,0.95-4.54,1.98
					c-5.46,3.47-6.86,9.3-7.23,12.62v11.01h42.86V66.685z"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="103.235"
                y1="77.195"
                x2="103.235"
                y2="68.445"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="126.535"
                y1="77.195"
                x2="126.535"
                y2="68.445"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M126.855,32.265c-0.64-2.12-1.72-4.35-3.62-5.07c-2.35-0.88-4.23,1-7.87,1.2c-0.17,0.01-0.35,0.01-0.52,0.01
					c-0.17,0-0.35,0-0.52-0.01c-3.64-0.2-5.52-2.08-7.87-1.2c-1.9,0.72-2.99,2.95-3.64,5.07c0,0.01,0,0.01,0,0.02
					c0-0.01,0-0.01-0.01-0.02c-0.33-0.9-1.18-3.7-0.25-6.9c0.26-0.88,1.08-3.24,3.3-5.06c3.07-2.53,7.06-2.56,8.63-2.57
					c0.07,0,0.13,0,0.16,0c0.07,0,0.13,0,0.2,0s0.13,0,0.2,0c0.03,0,0.08,0,0.16,0c1.57,0.01,5.55,0.04,8.63,2.57
					c2.22,1.82,3.04,4.18,3.3,5.06c0.93,3.2,0.07,6-0.27,6.9c-0.01,0.01-0.01,0.01-0.01,0.02
					C126.855,32.275,126.855,32.275,126.855,32.265z"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M126.855,32.265h0.01c0.27,0.05,0.53,0.13,0.74,0.28c1.43,0.95,0.6,3.83,0.5,4.15c-0.42,1.37-1.25,2.26-1.73,2.68
					c-0.31,1.23-1.3,4.45-4.29,7.02c-0.64,0.55-3.63,3.11-7.14,3.01c-0.04,0-0.07,0-0.1,0c-0.04,0-0.06,0-0.09,0
					c-3.53,0.1-6.51-2.46-7.15-3.01c-3-2.57-3.99-5.79-4.3-7.02c-0.48-0.42-1.31-1.31-1.72-2.68c-0.11-0.32-0.94-3.2,0.5-4.15
					c0.21-0.14,0.45-0.23,0.72-0.28h0.01"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Layer_1"></g>
    </SvgIcon>
  )
}

export default ExpertisesIcon
